import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Button, Modal, Typography, Box } from "@mui/material";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";

const SuccessModal = ({ open, onClose, cart, customerDetails,campaignCode }) => {
  const navigate = useNavigate();

  const handleDownloadReceipt = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Order Invoice", 20, 20);
    doc.setFontSize(12);
    doc.text(`Customer: ${customerDetails?.name || "Unknown"}`, 20, 30);
    doc.text(`Phone: ${customerDetails?.phone || "-"}`, 20, 38);

    let y = 50;
    cart.items.forEach((item, index) => {
      doc.text(
        `${index + 1}. ${item.title} x ${item.qty} = Kes ${(
          item.qty * item.price
        ).toLocaleString()}`,
        20,
        y
      );
      y += 10;
    });

    doc.text(`------------------------------`, 20, y + 5);
    doc.text(
      `Total: Kes ${cart.items
        .reduce((sum, item) => sum + item.price * item.qty, 0)
        .toLocaleString()}`,
      20,
      y + 15
    );

    doc.save("order-receipt.pdf");
  };


const handleBackHome = () => {
  if (campaignCode) {
    navigate(`/${campaignCode}`);
  } else {
    navigate("/"); // fallback if code is missing
  }
};

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "1rem",
          padding: "2rem",
          maxWidth: 500,
          width: {
            xxs: "100%",
            xs: "100%",
            sm: "100%",
            md: "400px",
            lg: "500px",
          },
          mx: "auto",
          mt: "10vh",
          textAlign: "center",
          boxShadow: 24,
        }}
      >
        <DotLottieReact
          src="https://lottie.host/e072fb03-8ad8-4588-822d-3f80af348f2d/IREbiuPWov.lottie"
          autoplay
          loop={false}
          style={{ height: 180, marginBottom: "1rem" }}
        />
        <Typography variant="h5" fontWeight={600} mb={2}>
          Order Placed Successfully!
        </Typography>
        <Typography variant="body1" mb={3}>
          Thank you, {customerDetails?.accountName || "Customer"}.
          <br />
          Your order has been placed.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={handleDownloadReceipt}
          sx={{ mb: 2 }}
        >
          Download Receipt
        </Button>
        <Button variant="outlined" fullWidth onClick={handleBackHome}>
          Back Home
        </Button>
      </Box>
    </Modal>
  );
};

export default SuccessModal;
